import { render, staticRenderFns } from "./Sentenca.vue?vue&type=template&id=32d045fa&scoped=true&"
import script from "./Sentenca.vue?vue&type=script&lang=js&"
export * from "./Sentenca.vue?vue&type=script&lang=js&"
import style0 from "./Sentenca.vue?vue&type=style&index=0&id=32d045fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d045fa",
  null
  
)

export default component.exports